import React, {useState} from 'react'
import LookupSearch from './LookupSearch'
import ReviewResults from './LookupResults'
import NotFound from '../../pages/NotFound'
import ErrorBoundary from '../ErrorBoundary'

const LookupHome = props => {
    const {handleClose, exactMatchFn} = props
    const [nextStep, setnextStep] = useState('LookupHome')

    let component = null

    switch (nextStep) {
        case 'LookupHome':
            component = (
                <LookupSearch
                    exactMatchFn={exactMatchFn}
                    callbackfunction={setnextStep}
                    handleClose={handleClose}
                />
            )
            break
        case 'ReviewResults':
            component = (
                <ReviewResults
                    exactMatchFn={exactMatchFn}
                    callbackfunction={setnextStep}
                    handleClose={handleClose}
                />
            )
            break
        default:
            component = <NotFound />
    }
    return (
        <>
            <ErrorBoundary>{component}</ErrorBoundary>
        </>
    )
}

export default LookupHome
